export const TITLE = "Generar cupón";
export const DESCRIPTION =
  "En la siguiente tabla podrá seleccionar las tasas correspondientes a cada artículo que desea pagar. Se generará un cupón con la suma de las tasas seleccionadas";
